// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"302":"cf44f316","453":"1dd76cfc"}[chunkId] + ".chunk.js";
};